/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_FcmInputs */

const en_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const ar_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسائل فايربيس`)
};

const bn_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const de_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const es_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const fr_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const pt_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const zh_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const tr_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const ru_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

const pl_svchip_fcm = /** @type {(inputs: Svchip_FcmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FCM`)
};

/**
* | output |
* | --- |
* | "FCM" |
*
* @param {Svchip_FcmInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_fcm = /** @type {((inputs?: Svchip_FcmInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_FcmInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_fcm(inputs)
	if (locale === "bn") return bn_svchip_fcm(inputs)
	if (locale === "de") return de_svchip_fcm(inputs)
	if (locale === "es") return es_svchip_fcm(inputs)
	if (locale === "fr") return fr_svchip_fcm(inputs)
	if (locale === "pt") return pt_svchip_fcm(inputs)
	if (locale === "zh") return zh_svchip_fcm(inputs)
	if (locale === "tr") return tr_svchip_fcm(inputs)
	if (locale === "ru") return ru_svchip_fcm(inputs)
	if (locale === "pl") return pl_svchip_fcm(inputs)
	return en_svchip_fcm(inputs)
});